<template>
    <div class="collapsible-body">
        <div class="row baseheader" style="width: 100%;" v-if="newDevType == undefined">
            <div class="col s1">
            </div>
            <div class="col s3 input-field">
                <span v-on:click="setDevTypesOrder('name')">{{$t('dev_types.name')}}</span>
                <i class="material-icons dp6" v-if="orderdevtypesby == 'name' && orderdevtypes == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="orderdevtypesby == 'name' && orderdevtypes == 'asc'">arrow_drop_up</i>
                <input v-model="devtypessearch" />
            </div>
            <div class="col s3 input-field">
                <span v-on:click="setDevTypesOrder('prefix')">{{$t('dev_types.prefix')}}</span>
                <i class="material-icons dp6" v-if="orderdevtypesby == 'prefix' && orderdevtypes == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="orderdevtypesby == 'prefix' && orderdevtypes == 'asc'">arrow_drop_up</i>
                <input v-model="devtypesprefixsearch" />
            </div>
            <div class="col s3 input-field">
                <span v-on:click="setDevTypesOrder('category_name')">{{$t('dev_types.device_category')}}</span>
                <i class="material-icons dp6" v-if="orderdevtypesby == 'category_name' && orderdevtypes == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="orderdevtypesby == 'category_name' && orderdevtypes == 'asc'">arrow_drop_up</i>
                <selector v-model="device_categories_selected" :items="device_categories_options" identifier="devicecategories"></selector>
            </div>
            <div class="col s2 input-field" style="text-align: end;" v-if="role == 'ddd_admin' || (role == 'ddd_worker' && extended_priviliges)"><a class="waves-effect waves-light btn solidgreen" v-on:click="addDevType()" style="margin-top: 20px;">{{$t('dev_types.add')}}</a></div>
        </div>
        <ul class="collapsible">
            <li v-if="newDevType != undefined">
                <devtype 
                    v-bind:dev_type="newDevType" 
                    v-bind:device_categories="device_categories" 
                    v-bind:substances="substanceoptions" 
                    v-bind:pestgroups="pest_groups_options" 
                    v-on:addDevType="addedDevType"  
                    v-on:cancelDevType="devtypeCancelled"
                    :extended_privileges="extended_privileges"
                    ref="newDevType"/>
            </li>
            <li v-for="devtype in listDevTypes" :key="devtype.id">
                <div class="collapsible-header reded">
                    <div class="row" style="width: 100%;">
                        <div class="col s1">
                            <template v-if="devtype.photo != null && devtype.photo != undefined">
                                <v-lazy-image
                                    v-bind:src="devtype.photo"
                                    src-placeholder="/nofoto.png"
                                    width="64"
                                    v-on:error="imageLoadError(devtype)" />
                            </template>
                            <template v-else>
                                <img src="/nofoto.png" style="width: 64px;"/>
                            </template>
                        </div>
                        <div class="col s3"> {{devtype.name}}</div>
                        <div class="col s3"> {{devtype.prefix}}</div>
                        <div class="col s3"> {{devtype.category_name}}</div>
                    </div>
                </div>
                <devtype 
                    v-bind:dev_type="devtype" 
                    v-bind:device_categories="device_categories" 
                    v-bind:substances="substanceoptions" 
                    v-bind:pestgroups="pest_groups_options" 
                    v-on:removeDevType="removeDevType"
                    :extended_privileges="extended_privileges"
                    ref="devtypes"/>
            </li>
            <li>
                <div class="row" style="width: 100%;" v-if="devtypes_loaded == false">
                    <div class="col s12">
                        <div class="container" style="width: 3%; margin: auto;">
                            <div class="preloader-wrapper active">
                                <div class="spinner-layer spinner-red-only">
                                    <div class="circle-clipper left">
                                        <div class="circle"></div>
                                    </div>
                                    <div class="gap-patch">
                                        <div class="circle"></div>
                                    </div>
                                    <div class="circle-clipper right">
                                        <div class="circle"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="width: 100%;" v-if="devtypes_loaded == true && listDevTypes.length == 0">
                    {{$t('dev_types.no_dev_types_found')}}
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import _ from 'lodash';

export default {
    props: { role: String, extended_privileges: Boolean },
    data: function() {
        return {
            orderdevtypes: 'desc',
            orderdevtypesby: 'name',
            devtypessearch: "",
            devtypesprefixsearch: "",
            pests: [],
            substances: [],
            dev_types: [],
            device_categories: [],
            device_categories_options: [],
            device_categories_selected: [],
            pest_groups: [],
            pest_groups_options: [],
            substance_groups: [],
            devtypes: [],
            materials: [],
            workers: [],
            pests_loaded: false,
            substances_loaded: false,
            materials_loaded: false,
            workers_loaded: false,
            devtypes_loaded: false,
            devicecategories_loaded: false,
            loaded: false,
            substancegroups: [],
            substancegroupoptions: [],
            pestsgroups: [],
            peststagsgroups: [],
            selectedpestsgroups: [],
            selectedpesttags: [],
            selectedsubstancesgroups: [],
            substanceoptions: [],
            tranch_length: 50,
            newDevType: undefined
        }
    },
    created() {
        this.fetch_pests();
    },
    mounted() {
        var elems = document.querySelectorAll('.collapsible');
        var instances = M.Collapsible.init(elems, { accordion: true });
    },
    methods: {
        removeDevType: function(dev_type) {
            if (confirm("Czy chcesz usunąć " + dev_type.name + " ?")) {
                var that = this;
                axios.delete("/dev_types/" + dev_type.id + ".json").then((response) => {
                    that.devtypes.splice(that.devtypes.indexOf(dev_type), 1);
                })
            }
        },
        anyEdited: function(){
            if(_.isUndefined(this.$refs.devtypes) == false){
                for (var i = this.$refs.devtypes.length - 1; i >= 0; i--) {
                    if(this.$refs.devtypes[i].edited_dev_type.edit){
                        return true;
                    }
                }
            }
            if(_.isUndefined(this.$refs.newDevType) == false){
                if(this.$refs.newDevType.edited_dev_type.edit){
                    return true;
                }
            }
            return false;
        },
        addedDevType: function(devtype) {
            this.newDevType = undefined;
            this.devtypes.push(devtype)
        },
        fetch_pests: function() {
            var that = this;
            axios.get('/dev_types.json').then(response => {
                this.devtypes = response.data;
                for (var i = this.devtypes.length - 1; i >= 0; i--) {
                    this.devtypes[i].edit = false;
                    this.device_categories_options = _.uniq(_.union(this.device_categories_options, [this.devtypes[i].category_name]))
                }
                this.device_categories_options = _.map(this.device_categories_options, pestgroup => {
                    return { name: pestgroup, value: pestgroup };
                })
                this.devtypes_loaded = true;
            });
            axios.get('/device_categories.json').then(response => {
                this.device_categories = response.data;
                for (var i = this.device_categories.length - 1; i >= 0; i--) {
                    this.device_categories[i].edit = false;
                }
                this.devicecategories_loaded = true;
            });
            axios.get('/substances.json').then(response => {
                this.substances = response.data;
                this.substanceoptions = []
                for (var i = this.substances.length - 1; i >= 0; i--) {
                    this.substances[i].edit = false;
                    this.substancegroups = _.uniq(_.union(this.substancegroups, this.substances[i].group))
                    this.substanceoptions.push({ name: this.substances[i].name, value: this.substances[i].id })
                }
                this.substancegroups = _.map(this.substancegroups, pestgroup => {
                    return { name: pestgroup, value: pestgroup };
                })

                this.substances_loaded = true;
            });
            axios.get('/groups.json').then(response => {
                this.pest_groups = response.data;
                this.pest_groups_options = _.map(this.pest_groups, pestgroup => {
                    return { name: pestgroup.name, value: pestgroup.id };
                })
            });
            axios.get('/substances/groups.json').then(response => {
                this.substance_groups = response.data;
            });
        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },

        addDevType() {
            this.newDevType = { edit: true, editable: true, tag_list: [], name: "", photo: "", group_ids: [], substance_ids: [], zone: "outer", maintenaces: [], media: [] }
            this.$forceUpdate();
        },
        setDevTypesOrder: function(order) {
            if (this.orderdevtypesby == order) {
                if (this.orderdevtypes == 'desc') {
                    this.orderdevtypes = 'asc'
                } else if (this.orderdevtypes == 'asc') {
                    this.orderdevtypes = 'desc'
                }

            } else {
                this.orderdevtypesby = order;
            }
        },
        devtypeCancelled(){
          this.newDevType = undefined
        },
        imageLoadError: function(devtype){
            devtype.photo = null;
        }
    },
    computed: {
        listDevTypes() {
            var that = this;
            return _.filter(
                _.orderBy(this.devtypes, this.orderdevtypesby, this.orderdevtypes),
                function(item) {
                    return (
                        ((item.name || "").toUpperCase().indexOf(that.devtypessearch.toUpperCase()) >= 0) &&
                        ((item.prefix || "").toUpperCase().indexOf(that.devtypesprefixsearch.toUpperCase()) >= 0) &&
                        (_.includes(that.device_categories_selected, item.category_name) || that.device_categories_selected.length == 0)
                    )
                }
            );
        },
    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.settingsform {
    padding-top: 15px;
}

.login_button {
    color: red;
}

p {
    font-size: 2em;
    text-align: center;
}

.selectorignored select {
    display: block;
}

.formul .row .col {
    padding-bottom: 15px;
}

.formul .s12 .input-field {
    width: 90%
}

.formul .s4 .input-field {
    width: 60%
}

.formul .s6 .input-field {
    width: 60%
}

.input-field {
    margin: 0px !important;
}

.settingsform>.row {
    margin-bottom: 0px;
}

.settingsform>.row>.collapsible {
    margin-bottom: 0px;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.collapsible-header {
    background-color: #8A8D91;
    text-transform: uppercase;
}

.collapsible-body .collapsible-header {
    background-color: #FFF;
    text-transform: initial;
}

.collapsible-body .collapsible-header .row {
    margin-bottom: 0px;
}

.collapsible-body .collapsible-body.formul {
    background-color: #FFF;
    margin-top: 5px;
    border-bottom-style: solid;
    border-bottom-width: 5px;
}

.baseheader {
    background-color: #DADADA;
    margin-bottom: 0px;
}

.collapsible {

    margin-left: 15px;
    margin-right: 15px;
    box-shadow: 0 0px 0px;
    border: 0px;
}

.collapsible li {
    padding-bottom: 15px;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.solidgreen {
    background-color: #00CC66 !important;
    color: black;
}

.active>.reded {
    border-color: rgb(194, 32, 38);
    border: 4px solid rgb(194, 32, 38);
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.inline>select {
    display: block !important;
}

.collapsible-body {
    padding: 1em;
    padding-right: 0em;
    padding-left: 1em;
}

.collapsible li i {
    position: absolute;
    right: 15px;
}

.collapsible li.active i {
    -ms-transform: rotate(180deg);
    /* IE 9 */
    -webkit-transform: rotate(180deg);
    /* Chrome, Safari, Opera */
    transform: rotate(180deg);
}

.input-field {
    margin-top: 0rem;
    margin-bottom: 0rem;
}

.btn-small {
    color: black;
    border-radius: 8px;
}
</style>